import { render, staticRenderFns } from "./listv2.vue?vue&type=template&id=034ae96a&"
import script from "./listv2.vue?vue&type=script&lang=js&"
export * from "./listv2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports